import { HUBBLE_MIXPANEL_ID } from "~/data/consts";
import { MixpanelAnalyticsPlatform } from "./analytics_platforms/mixpanel_analytics_platform";
import { IAnalyticsService } from "./IAnalyticsService";
import { config } from "~/data/config";

class HubbleAnalyticsService implements IAnalyticsService {
  mixpanelAnalyticsPlatform?: IAnalyticsPlatform;
  defaultProperties?: Record<string, any>;

  initialised = false;

  initialise = () => {
    if (!this.initialised) {
      this.mixpanelAnalyticsPlatform = new MixpanelAnalyticsPlatform(
        HUBBLE_MIXPANEL_ID
      );
      this.initialised = true;
    }
  };

  constructor(props: { defaultProperties?: Record<string, any> }) {
    this.defaultProperties = props.defaultProperties;
    // this.initialise();
  }

  logEvent(event: string, properties?: Record<string, any>): void {
    try {
      this.initialise();

      if (config.env == "Prod") {
        this.mixpanelAnalyticsPlatform?.trackEvent(event, {
          ...this.defaultProperties,
          ...properties,
        });
      }
    } catch (error) {
      console.error("Error logging event", error);
    }
  }

  setIdentity(identity: string): void {
    this.initialise();
    this.mixpanelAnalyticsPlatform?.setIdentity(identity);
  }

  logout(): void {
    this.initialise();
    this.mixpanelAnalyticsPlatform?.logout();
  }
}

export default HubbleAnalyticsService;
